import axios from 'axios';
import Spinner from 'reactstrap/es/Spinner';
import Table from 'reactstrap/es/Table';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import { usePromise } from '../../../Utils/usePromise';
import { getString } from '../../../Utils/getString';
import 'numeral/locales/ru';
import { parseApiError } from '@yooink/youtils/es/ParseApiError';

export function PopularProducts ({ from, to }) {
	const { isLoading, isError, data = {}, errData } = usePromise(() => axios.get('/api/v2/analytics/general/popularProducts', { params: { from, to } })
			.then((res) => res.data), [from.getTime(), to.getTime()]);

	const { items } = data;

	return (
		<>
			<div>
				<div className="d-flex mb-4 align-items-center">
					<h2 className="mr-3 mb-0">
						Популярные товары
					</h2>
				</div>
				{isLoading && <Spinner />}
				{!isLoading && isError && parseApiError(errData)}
				{!isLoading && !isError && (
					<Table responsive>
						<thead>
							<tr>
								<th>Название товара</th>
								<th>Кол-во шт</th>
								<th>Цена</th>
							</tr>
						</thead>
						<tbody>
							{items.map((item) => (
								<tr>
									<th scope="row"><Link to={`/products/view/${item._id}`}>{item.name}</Link></th>
									<td>{item.rating}</td>
									<td>{numeral(item.rating * item.price).format('0,0')} ₽</td>
								</tr>
							))}
						</tbody>
					</Table>
				)}
			</div>
		</>
	);
}
